import { Badge } from '../../../components/ui/Badge'
import type { TaskPriority } from '../../../api/types'

const PRIORITY_CONFIG: Record<TaskPriority, { label: string; variant: 'neutral' | 'info' | 'warning' | 'danger' }> = {
  LOW: { label: 'Niedrig', variant: 'neutral' },
  MEDIUM: { label: 'Mittel', variant: 'info' },
  HIGH: { label: 'Hoch', variant: 'warning' },
  CRITICAL: { label: 'Kritisch', variant: 'danger' },
}

export function PriorityBadge({ priority }: { priority: TaskPriority }) {
  const config = PRIORITY_CONFIG[priority]
  return (
    <Badge variant={config.variant} dot>
      {config.label}
    </Badge>
  )
}

export const PRIORITY_OPTIONS: { value: TaskPriority; label: string }[] = (Object.keys(PRIORITY_CONFIG) as TaskPriority[]).map((value) => ({
  value,
  label: PRIORITY_CONFIG[value].label,
}))
